import React, { useCallback, useEffect, useRef, useState } from 'react';
import {Row,Col} from 'antd';
import GoogleMapReact from 'google-map-react';
import { SoilProfileMarkerSelect, SoilProfileMarker, SoilSearchProfileCount } from '../../resource/IconComponentSets';
import './index.less';
import useSupercluster from 'use-supercluster';
interface ChildProps {
    lat?:number
    lng?:number
    marker?:any
    onClick?:(param:any)=>void
    isHidden?:boolean
    markerClick?:(param:any,visible:boolean)=>void
    selected?:boolean
    layer:any[]
}

const AnyReactComponent = (props:ChildProps) => {
    const [isShow,setIsShow] = useState(false);
    const {marker} = props;
    useEffect(()=>{
        // setIsShow(false);
    },[props.isHidden]);
    const markClick = async (visible)=>{
        await props.markerClick(marker,visible);
        setIsShow(visible);
    };
    return (
        <div className='popFather' >
            <div
                onMouseEnter={e=>markClick(true)}
                onMouseLeave={e=>markClick(false)}
            >
                <SoilProfileMarker className='marker-svgIcon'
                    onClick={e=>console.log(e)}/>
            </div>
            <div className={isShow?"popDiv":"popDiv hidden"}>
                <Row className="popTitle">
                    <Col span={12}>
                        <div className="top">{marker.profileName}</div>
                        <div className="bottom">{marker.profileCode}</div>
                    </Col>
                    <Col span={12}>
                        <span className="btns">{marker.profileStatus}</span>
                    </Col>
                </Row>
                <div className="popContent">
                    <Row>
                        <Col span={12}>
                            <div className="contentTitle">Location</div>
                            <div className="contentValue">{marker.profilePlaceName}</div>
                        </Col>
                        <Col span={12}>
                            <div className="contentTitle">Type</div>
                            <div className="contentValue">{marker.profileFityName}</div>
                        </Col>

                        {
                            props.layer.map((e,k)=>{
                                return (<Col span={12} key={k}>
                                    <div className="contentTitle">{e.layerRank}</div>
                                    <div className="contentValue">{e.thickNess.replace(/,/g,'-')} cm</div>
                                </Col>);
                            })
                        }


                    </Row>
                </div>
                <div className="popFooter">
                    Soil Profile
                </div>
            </div>
        </div>
    );
};

interface Iprops {
    marks:any
    selectId:[]
    isNew:boolean
    defaultCenter:any
    layer?:any[]
    markerClick?:(param:any)=>void
}

const TemplateGoogleMap = (props:Iprops)=> {
    // console.log('props.marks:=====', props.marks);
    const [bounds, setBounds] = useState(null);
    const [zoom, setZoom] = useState(10);
    const [points, setPoints] = useState([]);

    const defaultProps = {
        center: {lat: 59.95, lng: 30.33},
        zoom: 1
    };

    useEffect(() => {
        console.log(props.marks);
        // if (props.marks.length > 0) {
        const geoJsonPoints = props.marks.map((item, index) => {
            return {
                type: 'Feature',
                properties: {
                    cluster: false,
                    crimeId: `${item.countryCode}-${index}`,
                    category: 'anti-social-behaviour'
                },
                geometry: {
                    type: 'Point',
                    coordinates: [
                        item.profileLongitude,
                        item.profileLatitude
                    ]
                },
                marker:item
            };
        });
        setPoints(geoJsonPoints);
        // }
    }, [props.marks]);

    const [defaultCenterProp,setDefaultCenterProp] = useState({lat: 59.95, lng: 30.33});
    const markerClicked = (marker)=> {
        props.markerClick(marker);
        console.log("The marker that was clicked is", marker);
    };
    const [isHidden,setIsHidden] = useState(false);
    const markerClick = (marker,param)=>{
        props.markerClick(marker);
    };

    const { clusters } = useSupercluster({
        points,
        bounds,
        zoom,
        options: { radius: 130, maxZoom: 20 }
    });

    const [updateBug,setUpdateBug] = useState(false);
    useEffect(()=>{
        console.log('selected:',props.marks,props.layer,props.defaultCenter);
        if(props.defaultCenter!=null){
            setDefaultCenterProp(props.defaultCenter);
        }else{
            setDefaultCenterProp(defaultProps.center);
        }
        setUpdateBug(!updateBug);
    },[props.isNew]);

    // auto set center coordinate
    useEffect(() => {
        if (props.marks && props.marks.length > 0 && mapRef.current) {
            mapRef.current.setCenter({ lat: props.marks[0].profileLatitude, lng: props.marks[0].profileLongitude });
        }
    }, [props.marks]);

    const mapRef = useRef(null);
    const mapsRef = useRef(null);
    const handleGoogleApiLoaded = useCallback(({ map, maps }) => {
        mapRef.current = map;
        mapsRef.current = maps;
    }, []);

    return (
        <GoogleMapReact
            bootstrapURLKeys={{
                key: 'AIzaSyDlsxkoR8-fiIgncnDunmEtWEwDmr896H0'
            }}
            defaultCenter={defaultCenterProp}
            center={defaultCenterProp}
            defaultZoom={defaultProps.zoom}
            style={{height: 'calc(100vh - 121px)'}}
            onGoogleApiLoaded={handleGoogleApiLoaded}
            onChange={({ zoom, bounds }) => {
                setZoom(zoom);
                setBounds([
                    bounds.nw.lng,
                    bounds.se.lat,
                    bounds.se.lng,
                    bounds.nw.lat
                ]);
            }}
        >
            {clusters.length > 0 && clusters.map((cluster) => {
                const [longitude, latitude] = cluster.geometry.coordinates;
                const {
                    cluster: isCluster,
                    point_count: pointCount
                } = cluster.properties;
                if (isCluster) {
                    return (
                        <SoilSearchProfileCount
                            key={`cluster-${cluster.id}`}
                            lat={latitude}
                            lng={longitude}
                            className='marker-annotation-count'
                        >
                            <span
                                className={pointCount > 9 ? 'point-count-more-than-99-span' : 'point-count-span'}
                            >
                                {pointCount > 99 ? '99+' : pointCount}
                            </span>
                            {/* </div> */}
                        </SoilSearchProfileCount>
                    );
                }
                return (
                    <AnyReactComponent
                        key={cluster.marker.layerId}
                        lat={latitude}
                        lng={longitude}
                        marker={cluster.marker}
                        onClick={e=>markerClicked(cluster.marker)}
                        markerClick={markerClick}
                        isHidden={isHidden}
                        selected={props.selectId.filter(e=>e == cluster.marker.id).length==0}
                        layer={props.layer}
                    />
                );
            })}
        </GoogleMapReact>
    );
};
export default TemplateGoogleMap;